import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store';

export interface SignUpState {
  email: string;
  password: string;
}

const initialState: SignUpState = {
  email: '',
  password: '',
};

export type StoreSignUpDataPayload = SignUpState;

export const signUpSlice = createSlice({
  name: 'signUp',
  initialState,
  reducers: {
    storeSignUpData: (state, action: PayloadAction<StoreSignUpDataPayload>) => {
      state.email = action.payload.email;
      state.password = action.payload.password;
    },
    clearSignUpData: (state) => {
      state.email = initialState.email;
      state.password = initialState.password;
    },
  },
});

export const { storeSignUpData, clearSignUpData } = signUpSlice.actions;

export const getSignUpData = (state: RootState) => state.signUp;

export default signUpSlice.reducer;
